import Globals from "@/Components/Globals/Globals";
import { Router } from "react-router-dom";
import AppLoader from "./AppLoader";
import Providers from "./Providers";

const App = ({ history }: { history }) => {
  /*  const setConfirm = useSetConfirm();
  const getConfirm = (message: string, callback: (ok: boolean) => void) => {
    setConfirm({
      message,
      cb: () => callback(true),
    });
  }; */
  return (
    <Router history={history}>
      <Providers>
        <Globals />
        <AppLoader />
      </Providers>
    </Router>
  );
};

export default App;
